<template>
  <div class="mcontainer">
    <div class="breadcrumb-area py-0">
      <div class="breadcrumb">
        <ul class="m-0">
          <li><router-link to="/app/admin/events">Events Admin</router-link></li>
          <li class="active"><a href="#">Create Event</a></li>
        </ul>
      </div>
    </div>
    <div class="max-w-5xl m-auto shadow-md rounded-md bg-white mt-5">
      <form @submit.prevent="actionSubmit()">
        <div class="text-center border-b py-4">
          <h3 class="font-bold text-lg">Create Event</h3>
        </div>
        <div class="p-7 space-y-5">
          <div>
            <label class="font-semibold">Judul *</label><br>
            <input class="form-control" v-model="form.title" type="text" required placeholder="Judul event">
          </div>
          <div>
            <label class="font-semibold">Deskripsi</label><br>
            <Editor v-model="form.description" />
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div>
              <label class="font-semibold">Lokasi</label><br>
              <input class="form-control" v-model="form.location" type="text" placeholder="Lokasi event">
            </div>
            <div>
              <label class="font-semibold">Tanggal & Waktu</label><br>
              <input class="form-control" v-model="form.event_date" type="datetime-local">
            </div>
          </div>
          <div>
            <label class="font-semibold">URL Pendaftaran</label><br>
            <input class="form-control" v-model="form.register_url" type="url" placeholder="https://...">
          </div>
          <div>
            <label class="font-semibold">Tampilkan tombol Register</label>
            <div class="flex items-center gap-2 mt-1">
              <input type="checkbox" v-model="form.show_button" id="show_button" class="checkbox-register">
              <label for="show_button" class="cursor-pointer text-sm font-normal">Centang untuk menampilkan</label>
            </div>
          </div>
          <div>
            <label class="font-semibold">Status</label><br>
            <select class="form-control" v-model="form.status">
              <option value="active">Aktif</option>
              <option value="inactive">Tidak Aktif</option>
            </select>
          </div>
          <div>
            <label class="font-semibold">Gambar</label><br>
            <div class="image-uploader">
              <input type="file" ref="imageInput" @change="onFileSelected" accept="image/*">
              <span @click="$refs.imageInput.click()"><Icon icon="bi:cloud-upload" /></span>
              <img :src="preview || $placeholder2" alt="Preview" class="w-80 max-h-48 object-cover rounded">
            </div>
          </div>
        </div>
        <div class="border-t flex justify-center gap-3 border-gray-100 p-6">
          <router-link to="/app/admin/events" class="btn btn-secondary">Batal</router-link>
          <button type="submit" class="btn btn-primary" :disabled="submitting">
            <span v-if="!submitting">Create Event</span>
            <b-spinner v-if="submitting" small />
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { Icon } from '@iconify/vue2'
import Editor from '@/components/Editor'

export default {
  name: 'EventAdminCreate',
  components: { Icon, Editor },
  data () {
    return {
      form: {
        title: '',
        description: '',
        location: '',
        event_date: '',
        register_url: '',
        show_button: true,
        status: 'active',
        image: null
      },
      preview: '',
      submitting: false
    }
  },
  methods: {
    getErrorDetail (e) {
      const res = e.response
      if (!res) {
        return `<p><strong>Koneksi gagal:</strong> ${e.message || 'Tidak dapat terhubung ke server'}</p>`
      }
      const data = res.data || {}
      const status = res.status
      let html = `<p><strong>Status:</strong> ${status}</p>`
      // Laravel: data.errors | Lumen: data bisa berisi errors di root (field -> array of messages)
      const rootErrs = status === 422 && typeof data === 'object' && !Array.isArray(data)
        ? Object.fromEntries(Object.entries(data).filter(([k, v]) => !['message', 'status', 'error', 'exception'].includes(k) && Array.isArray(v)))
        : null
      const errs = data.errors || (rootErrs && Object.keys(rootErrs).length > 0 ? rootErrs : null)
      if (errs && typeof errs === 'object') {
        const list = Object.entries(errs)
          .filter(([, v]) => v != null)
          .map(([field, msgs]) => `<li><strong>${field}:</strong> ${Array.isArray(msgs) ? msgs.join(', ') : String(msgs)}</li>`)
          .join('')
        if (list) html += `<p><strong>Validasi:</strong></p><ul style="text-align: left; margin: 8px 0;">${list}</ul>`
      }
      if (data.message) {
        html += `<p><strong>Pesan:</strong> ${data.message}</p>`
      }
      if (data.error || data.exception) {
        html += `<p><strong>Detail:</strong> ${data.error || data.exception}</p>`
      }
      const hasDetail = (errs && Object.keys(errs).length > 0) || data.message || data.error || data.exception
      if (!hasDetail) {
        html += `<p>${e.message || 'Gagal membuat event'}</p>`
      }
      return html
    },
    onFileSelected (e) {
      const file = e.target.files[0]
      if (file) {
        this.form.image = file
        this.preview = URL.createObjectURL(file)
      }
    },
    async actionSubmit () {
      this.submitting = true
      try {
        const formData = new FormData()
        formData.append('title', this.form.title)
        formData.append('description', this.form.description)
        formData.append('location', this.form.location)
        if (this.form.event_date) formData.append('event_date', this.form.event_date)
        if (this.form.register_url) formData.append('register_url', this.form.register_url)
        formData.append('show_button', this.form.show_button ? 1 : 0)
        formData.append('status', this.form.status)
        if (this.form.image) formData.append('image', this.form.image)

        await axios.post('/admin/events', formData)

        this.$swal({
          icon: 'success',
          title: 'Berhasil',
          text: 'Event berhasil dibuat'
        }).then(() => {
          this.$router.push({ name: 'EventAdmin' })
        })
      } catch (e) {
        const detail = this.getErrorDetail(e)
        this.$swal({
          icon: 'error',
          title: 'Gagal Membuat Event',
          html: detail,
          width: 500
        })
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.form-control { width: 100%; padding: 8px 12px; border: 1px solid #e5e7eb; border-radius: 8px; }
.image-uploader { display: flex; flex-direction: column; gap: 8px; }
.image-uploader span { cursor: pointer; color: #3b82f6; }
.btn { padding: 8px 16px; border-radius: 8px; text-decoration: none; display: inline-flex; align-items: center; gap: 6px; }
.btn-primary { background: #2563eb; color: #fff; border: none; cursor: pointer; }
.btn-secondary { background: #e5e7eb; color: #374151; }
</style>
